import React from 'react'

import { getIn, FieldProps, Field } from 'formik'

import { AnimatedField, FormikInput } from './FormikTextInput.styled'

type FormikTextInputProps = {
    name: string
    label: string
    type?: 'text' | 'email' | 'url' | 'tel'
    disabled?: boolean
    placeholder?: string
    prefilled?: boolean
    infoText?: string
    maxLength?: number | undefined
}

function FormikTextInput({
    name,
    placeholder = '',
    label,
    disabled = false,
    type = 'text',
    prefilled = false,
    infoText = '',
    maxLength = undefined,
}: Readonly<FormikTextInputProps>) {
    return (
        <Field name={name}>
            {({ field, form }: FieldProps) => {
                const touched = getIn(form.touched, field.name)
                const error = getIn(form.errors, field.name)

                return (
                    <AnimatedField>
                        <FormikInput
                            type={type}
                            disabled={
                                disabled ||
                                form.values.disabledFields?.includes(field.name)
                            }
                            error={!!(touched && error)}
                            helpText={touched ? error : ''}
                            id={field.name}
                            name={field.name}
                            label={label}
                            infoText={infoText}
                            value={field.value}
                            onChange={(val: string) => {
                                const event = {
                                    target: {
                                        name,
                                        value: val,
                                    },
                                }

                                form.handleChange(event)
                            }}
                            onBlur={form.handleBlur}
                            placeholder={placeholder}
                            data-testid={name}
                            prefilled={prefilled}
                            maxLength={maxLength}
                        />
                    </AnimatedField>
                )
            }}
        </Field>
    )
}

export default FormikTextInput
